import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./../src/components/Navbar.jsx";
import Home from './pages/Home.jsx';
import Cursor from './components/Cursor.jsx';
import Footer1 from './components/Footer1.jsx';
import DigitalMarketing from './pages/DigitalMarketing.jsx';
import Uiux from './pages/UiUix.jsx';
import Contactus from './pages/Contactus.jsx';
import WhoWeAre from "./pages/WhoWeAre.jsx";
import Termsandconditions from './pages/TermsandConditions.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import Technology from './pages/TechnologyPage.jsx';
import QRCodeGenerator from './pages/QrGenerator.jsx';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes className="mt-4px">
        <Route path="/" element={<Home />} />
        <Route path="/technology-services" element={<Technology />} />
        <Route path="/digital-marketing-services" element={<DigitalMarketing />} />
        <Route path="/ui-ux-design-services" element={<Uiux />} />
        <Route path="/terms-and-conditions" element={<Termsandconditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-tes" element={<Contactus />} />
        <Route path="/whoweare" element={<WhoWeAre />} />
        <Route path="/qr-code-generator-tes" element={<QRCodeGenerator />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router className="mr-1px ml-1px">
      <Cursor />
      <Navbar className="overflow-hidden" />
      <AppRoutes />
      <Footer1 />
    </Router>
  );
}

export default App;